import React from 'react';
import classes from './ImageBG.module.scss';

const ImageBG = ({ src, className }) => {
  return (
    <img className={[classes.ImageBG, className].join(' ')} src={src} alt=""/>
  );
}

export default ImageBG;
